import $ from 'jquery'
import { Tabs } from './../../js/libraries/foundation'

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}

function init() {
  filters()
  archives()
  restoreFilterFocus()
}

function filters() {
  const controls = $('[data-controls-tabs]')

  if (!controls.length) return

  const controlsOptions = {
    activeCollapse: true
  }

  const controlsInit = new Tabs(controls, controlsOptions)

  const syncAriaExpanded = () => {
    controls.find('.tabs-title').each(function () {
      $(this).find('> a').attr('aria-expanded', $(this).hasClass('is-active') ? 'true' : 'false')
    })
  }

  controls.on('change.zf.tabs', syncAriaExpanded)
  controls.find('.tabs-title > a').on('click', () => setTimeout(syncAriaExpanded, 0))
}

function archives() {
  const archivesContainer = document.querySelector('[data-archives]')

  if (!archivesContainer) return

  const archivesLabel = archivesContainer.querySelector('label')
  const targetURL = archivesContainer.getAttribute('data-target')

  archivesLabel.addEventListener('click', () => {
    window.location.replace(targetURL)
  })
}

function restoreFilterFocus() {
  const urlParams = new URLSearchParams(window.location.search)

  if (urlParams.has('theme') || urlParams.has('archive')) {
    const activeFilter = document.querySelector('.Control-button.is-selected')
    const archiveCheckbox = document.querySelector('#archives')

    setTimeout(() => {
      if (activeFilter) {
        activeFilter.focus()
      } else if (urlParams.has('archive') && archiveCheckbox) {
        archiveCheckbox.focus()
      }
    }, 50)
  }
}